(function facetsAccordionExclusive() {
  'use strict';

  class FacetsAccordionExclusive {
    constructor() {
      this.drawerSelector = '.facets--drawer';
      this.horizontalSelector = '.facets--horizontal';
      this.accordionSelector = '.facets__item accordion-custom';
      this.detailsSelector = '.facets__item details';
      this.init();
    }

    init() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.setupEventListeners());
      } else {
        this.setupEventListeners();
      }
    }

    setupEventListeners() {
      this.observeDrawerState();
      this.observeAccordionChanges();
      this.setupHorizontalFilterConnection();
    }

    setupHorizontalFilterConnection() {
      document.addEventListener('click', (event) => {
        const clickedSummary = event.target.closest('.facets--horizontal .facets__item summary');
        if (!clickedSummary) {
          return;
        }

        const horizontalAccordion = clickedSummary.closest('accordion-custom');
        if (!horizontalAccordion) {
          return;
        }

        const filterParamName = horizontalAccordion.getAttribute('data-filter-param-name');
        if (!filterParamName) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();

        this.openDrawerAndAccordion(filterParamName);
      });
    }

    openDrawerAndAccordion(filterParamName) {
      const drawer = document.querySelector(this.drawerSelector);
      if (!drawer) {
        console.warn('Facets drawer not found');
        return;
      }

      const dialogComponent = drawer.closest('dialog-component');
      
      if (typeof drawer.showModal === 'function') {
        drawer.showModal();
        
        if (window.innerWidth >= 750) {
          this.addBackdropClickHandler(drawer, dialogComponent);
        }
      } else {
        drawer.setAttribute('open', '');
      }
      setTimeout(() => {
        this.openCorrespondingAccordion(filterParamName);
      }, 100);
    }

    addBackdropClickHandler(drawer, dialogComponent) {
      const handleBackdropClick = (event) => {
        if (event.target === drawer) {
          if (dialogComponent && typeof dialogComponent.closeDialog === 'function') {
            dialogComponent.closeDialog();
          } else {
            drawer.close();
          }
          drawer.removeEventListener('click', handleBackdropClick);
        }
      };

      drawer.addEventListener('click', handleBackdropClick);
    }

    openCorrespondingAccordion(filterParamName) {
      const drawer = document.querySelector(this.drawerSelector);
      if (!drawer) {
        return;
      }

      const drawerAccordion = drawer.querySelector(
        `accordion-custom[data-filter-param-name="${filterParamName}"]`
      );
      
      if (!drawerAccordion) {
        console.warn(`No accordion found in drawer with param name: ${filterParamName}`);
        return;
      }

      const drawerDetails = drawerAccordion.querySelector('details');
      if (!drawerDetails) {
        console.warn(`No details element found in drawer accordion: ${filterParamName}`);
        return;
      }

      this.closeOtherAccordions(drawerDetails);
      drawerDetails.setAttribute('open', '');
      drawerAccordion.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'nearest' 
      });
    }

    observeDrawerState() {
      const drawerObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
            const drawer = mutation.target;
            if (drawer.classList.contains('facets--drawer')) {
              if (drawer.hasAttribute('open')) {
                this.enableExclusiveMode();
              } else {
                this.disableExclusiveMode();
              }
            }
          }
        });
      });

      document.querySelectorAll(this.drawerSelector).forEach((drawer) => {
        drawerObserver.observe(drawer, { attributes: true });
      });
    }

    observeAccordionChanges() {
      const accordionObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
            const details = mutation.target;
            if (details.matches(this.detailsSelector)) {
              this.handleAccordionToggle(details);
            }
          }
        });
      });

      document.querySelectorAll(this.detailsSelector).forEach((details) => {
        accordionObserver.observe(details, { attributes: true });
      });
    }

    handleAccordionToggle(openedDetails) {
      const drawer = openedDetails.closest(this.drawerSelector);
      if (!drawer || !drawer.hasAttribute('open')) {
        return;
      }

      if (openedDetails.hasAttribute('open')) {
        this.closeOtherAccordions(openedDetails);
      }
    }

    closeOtherAccordions(excludeDetails) {
      const drawer = excludeDetails.closest(this.drawerSelector);
      if (!drawer) return;

      const otherOpenAccordions = drawer.querySelectorAll(
        `${this.detailsSelector}[open]`
      );

      otherOpenAccordions.forEach((accordion) => {
        if (accordion.id !== excludeDetails.id) {
          accordion.removeAttribute('open');
        }
      });
    }

    enableExclusiveMode() {
      const drawer = document.querySelector(this.drawerSelector);
      if (!drawer) return;

      const openAccordions = drawer.querySelectorAll(`${this.detailsSelector}[open]`);
      
      if (openAccordions.length > 1) {
        const firstOpen = openAccordions[0];
        this.closeOtherAccordions(firstOpen);
      }
    }

    disableExclusiveMode() {
      // Reset to default behavior when drawer closes
    }

    /**
     * Public method to manually enforce exclusive mode
     */
    enforceExclusiveMode() {
      this.enableExclusiveMode();
    }

    /**
     * Public method to open drawer and specific accordion
     * @param {string} filterParamName - The data-filter-param-name to open
     */
    openDrawerWithAccordion(filterParamName) {
      this.openDrawerAndAccordion(filterParamName);
    }

    disableExclusiveModeTemporarily() {
      // Remove event listeners temporarily
    }
  }

  const facetsAccordionExclusive = new FacetsAccordionExclusive();
  window.facetsAccordionExclusive = facetsAccordionExclusive;
})();